import { POPUP_TYPE, StateMsgType } from '@/models/Popup';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import {
    getHostLiveDataByHostId,
    hostLiveSliceActions,
} from '@/modules/hostLive/slice';
import { LiveDataSliceActions } from '@/modules/main/slice/liveData';
import { Action, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { getHostByGameId } from '../../../modules/host/slice';
import { popupSliceActions } from '../../../modules/popup/slice';
import store from '../../../store/store';
import { CMDSpForceStandDetails, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
import { GameError } from '@/models/games/enums/GameError';
import { inGamePopupSliceActions } from '@/modules/popup/inGameSlice';
import { GameType } from '@/models/games/enums/GameType';

export class CMDSpForceStandDetailsHandler extends AbstractHandler {
    _command: CMDSpForceStandDetails;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpForceStandDetails;
    }
    handle(dispatch: Dispatch<Action>): void {
        const state = store.getState();
        const host = getHostByGameId(state, this._command.GameID);
        if (host) {
            const hostLiveData = getHostLiveDataByHostId(state, host.HostId);
            batch(() => {
                dispatch(
                    hostLiveSliceActions.updateCountDown({
                        hostId: host.HostId,
                        countDown: host.GameDelay
                            ? host.GameDelay.kickNoBetPlayer
                            : 0,
                        canLeave: false,
                    })
                );
                if (hostLiveData.CurrentResult) {
                    if (this._command.Reason == GameError.BelowMinBet) {
                        dispatch(
                            inGamePopupSliceActions.updateIsOpen({
                                hostId: host.HostId,
                                isOpen: true,
                            })
                        );
                        dispatch(
                            inGamePopupSliceActions.updateDataSet({
                                hostId: host.HostId,
                                key: 'blackjack2.no_balance_continue',
                                gameType: GameType.Blackjack2,
                                stateMsgType: StateMsgType.betInfo_Warning,
                                gameId: this._command.GameID,
                            })
                        );
                    } else {
                        dispatch(
                            popupSliceActions.open(
                                'blackjack2.idle_kick',
                                POPUP_TYPE.ALERT,
                                undefined,
                                undefined,
                                undefined,
                                host.HostId
                            )
                        );
                    }
                    dispatch(
                        tableBetSliceActions.clearBets({
                            hostId: host.HostId,
                            gameId: hostLiveData.CurrentResult.GameID,
                        })
                    );
                    dispatch(
                        LiveDataSliceActions.updateHostBetInfo({
                            hostId: host.HostId,
                            totalBetAmount: 0,
                            totalWithHoldAmount: 0,
                            pendingBetAmount: 0,
                            pendingWithHoldAmount: 0,
                        })
                    );
                }
            });
        }
    }
}
